// Переход по якорю (`/s-12#s12-section-setup`) внутри уже открытой поверхности:
// адресная строка меняется, а фокус сам никуда не идёт. Меню сообщает о таком переходе,
// поверхность ставит фокус на название раздела (чтец его читает).

export const HASH_TARGET = "fortify:hash-target";

/** Меню: ссылка с якорем нажата — поверхность после перехода найдёт цель сама. */
export function announceHashTarget(hash: string): void {
  window.setTimeout(() => window.dispatchEvent(new CustomEvent<string>(HASH_TARGET, { detail: hash })), 0);
}

/**
 * Поставить фокус на цель якоря: название раздела с `id="title-<якорь>"` и `tabIndex=-1`.
 * Якорь — из события меню, а при открытии поверхности — из адреса. Нет якоря или цели — ничего.
 */
export function focusHashTarget(event?: Event): void {
  const named = event instanceof CustomEvent && typeof event.detail === "string" ? event.detail : null;
  const id = named ?? window.location.hash.slice(1);
  if (id === "") return;
  const target = document.getElementById(`title-${id}`);
  if (target === null) return;
  const calm = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? true;
  target.scrollIntoView?.({ block: "start", behavior: calm ? "auto" : "smooth" });
  target.focus({ preventScroll: true });
}
